export const UNAUTHORIZED = 401;
export const BAD_REQUEST = 400;
export const FORBIDDEN = 403;
export const TOO_MANY_REQUESTS = 429;
